import { render, staticRenderFns } from "./plus_detail.vue?vue&type=template&id=9f116132&scoped=true&"
import script from "./plus_detail.vue?vue&type=script&lang=js&"
export * from "./plus_detail.vue?vue&type=script&lang=js&"
import style0 from "./plus_detail.vue?vue&type=style&index=0&id=9f116132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f116132",
  null
  
)

export default component.exports